// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1xK8GS8MmAWri7tpOC4Z32_0","title":"_1qqB7tCS-Nbvy2xD5scd3t_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-402ff25c","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Report/Pie.vue
// module id = l/DY
// module chunks = 0